import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {IXNudgeData} from "../server/IData";
import {Symbol, WildStates, XNudgeStates} from "../reels/Symbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class XNudgeRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.xNudgeData.length > 0 && !Game.model.gameData.suspendedAction;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const featureTl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            xNudges: IXNudgeData[] = Game.model.xNudgeData;

        featureTl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(featureTl);
            });
        });

        xNudges.forEach((xNudge: IXNudgeData) => {
            const tl: gsap.core.Timeline = gsap.timeline(),
                xNudgeRowId: number = xNudge.rowId,
                xNudgeSymbol: Symbol = Game.reelsView.reelModels[xNudge.reelId].getSymbolAt(xNudgeRowId, "XN"),
                copyXNudgeSymbol: PIXI.spine.Spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("XN")),
                nudgeDownwardsRowId: number = xNudge.nudgeDownwardsRowId;

            copyXNudgeSymbol.position.set(xNudgeSymbol.position.x - (Game.hasGridExpanded ? 0 : 5), xNudgeSymbol.position.y); // #132, #105
            copyXNudgeSymbol.scale.set(Game.scaleFactor);
            Game.overlaysForSymbols.addChild(copyXNudgeSymbol);

            // #138
            if (xNudgeRowId >= nudgeDownwardsRowId) {
                tl.add([
                    Game.createTimelineForAnimation(copyXNudgeSymbol, 0, XNudgeStates.CAN_NOT_MOVE, false),
                    () => {
                        xNudgeSymbol.visible = false;
                    }
                ]);

                tl.add(() => {
                    xNudgeSymbol.visible = true;
                    xNudgeSymbol.updateTexture("W");

                    // add 1 value in the top right multiplier for every nudge symbol execution starting
                    Game.multiplier.updateMultiplier(1, true);
                }, "-=0.7");
            } else {
                tl.add(() => {
                    xNudgeSymbol.updateTexture("W");
                    xNudgeSymbol.getStateAnimationWithoutTL(WildStates.NUDGE_LAND);

                    // add 1 value in the top right multiplier for every nudge symbol execution starting
                    Game.multiplier.updateMultiplier(1, true);
                });
            }

            // nudge downwards
            for (let i: number = (xNudgeRowId + 1), j: number = 0; i <= nudgeDownwardsRowId; i++, j++) {
                tl.add([
                    Game.createTimelineForAnimation(copyXNudgeSymbol, 0, (i === nudgeDownwardsRowId) ? XNudgeStates.LAST_NUDGE : XNudgeStates.NUDGE, false),
                    () => {
                        Game.soundPlayer.playSound("xNudgeMove" + ((j % 4) + 1), 1);
                    }
                ]);
                tl.to(copyXNudgeSymbol, {
                    duration: 0.33333,
                    y: (i * Game.SYMBOL_HEIGHT),
                    onComplete: () => {
                        Game.multiplier.updateMultiplier(1, true);
                    }
                }, "<");

                const reelsSymName: string = Game.model.gameData.reels[xNudge.reelId][i],
                    sym: Symbol = Game.reelsView.reelModels[xNudge.reelId].getSymbolAt(i, reelsSymName === "XS" ? "W" : reelsSymName);
                tl.add(() => {
                    sym.updateTexture("W");
                    sym.getStateAnimationWithoutTL(XNudgeStates.NUDGE);
                }, "<+0.15");
            }

            tl.add(() => {
                copyXNudgeSymbol.parent.removeChild(xNudgeSymbol);
                copyXNudgeSymbol.destroy();
            });

            featureTl.add(tl);
        });
        if (Game.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            featureTl.timeScale(1.5);
        }
        featureTl.to(this, {
            duration: 0.1
        });
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }
}